import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { FaBolt } from "react-icons/fa";
import { GradientContainer } from "../animations/gradient-container";
import { Container } from "../ui/container";
import { Heading } from "../ui/heading";
import { Subheading } from "../ui/subheading";
import {
  Card,
  CardDescription,
  CardSkeletonContainer,
  CardTitle,
} from "./card";
import { FeatureIconContainer } from "./feature-icon-container";
import { SkeletonOne } from "./skeletons/first";
import { SkeletonFour } from "./skeletons/fourth";
import { SkeletonTwo } from "./skeletons/second";
import { SkeletonThree } from "./skeletons/third";

export const Features = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);
  return (
    <GradientContainer className="">
      <Container className="py-24 max-w-5xl mx-auto relative z-40 hidden md:block">
        <div data-aos="fade-down">
        <FeatureIconContainer className="flex justify-center items-center overflow-hidden">
          <FaBolt className="h-6 w-6 text-fuchsia-600" />
        </FeatureIconContainer>
        <Heading className="pt-4">Enhance Your Store Management</Heading>
        <Subheading>
          Whizmanage offers a comprehensive suite of features for efficient
          WooCommerce store management.
        </Subheading>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 py-10">
          <div data-aos="fade-down-right" className="lg:col-span-2">
            <Card>
              <CardTitle>Comprehensive Analytics</CardTitle>
              <CardDescription>
                Whizmanage offers extensive features for product editing,
                viewing, filtering, deleting, restoring, downloading, and
                saving. Enjoy a user-friendly interface packed with powerful
                tools.
              </CardDescription>
              <CardSkeletonContainer>
                <SkeletonOne />
              </CardSkeletonContainer>
            </Card>
          </div>
          <div data-aos="fade-down-left" className="lg:col-span-1">
            <Card>
              <CardSkeletonContainer className="max-w-[16rem] mx-auto">
                <SkeletonTwo />
              </CardSkeletonContainer>
              <CardTitle>Boost Your Sales</CardTitle>
              <CardDescription>
                Optimize store management with Whizmanage to drive sales growth
                and improve customer satisfaction.
              </CardDescription>
            </Card>
          </div>
          <div data-aos="fade-up-right" className="lg:col-span-1">
            <Card>
              <CardSkeletonContainer>
                <SkeletonThree />
              </CardSkeletonContainer>
              <CardTitle>Smart Integration</CardTitle>
              <CardDescription>
                Whizmanage seamlessly integrates with popular management and
                enhancement tools.
              </CardDescription>
            </Card>
          </div>
          <div data-aos="fade-up-left" className="lg:col-span-2">
            <Card>
              <CardSkeletonContainer
                showGradient={false}
                className="max-w-[16rem] mx-auto"
              >
                <SkeletonFour />
              </CardSkeletonContainer>
              <CardTitle>Advanced Editing Capabilities</CardTitle>
              <CardDescription>
                Whizmanage provides comprehensive control for editing and
                managing your store's products effortlessly.
              </CardDescription>
            </Card>
          </div>
          {/* <Card>
            <CardSkeletonContainer>
              <SkeletonFive />
            </CardSkeletonContainer>
            <CardTitle>Know Your Customers</CardTitle>
            <CardDescription>
              Create tailored funnels based on your target audience and drive
              more traffic to your store.
            </CardDescription>
          </Card> */}
        </div>
      </Container>
      <Container className="py-24 max-w-5xl mx-auto relative z-40 md:hidden">
        <div>
        <FeatureIconContainer className="flex justify-center items-center overflow-hidden">
          <FaBolt className="h-6 w-6 text-fuchsia-600" />
        </FeatureIconContainer>
        <Heading className="pt-4">Enhance Your Store Management</Heading>
        <Subheading>
          Whizmanage offers a comprehensive suite of features for efficient
          WooCommerce store management.
        </Subheading>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 py-10">
          <div className="lg:col-span-2">
            <Card>
              <CardTitle>Comprehensive Analytics</CardTitle>
              <CardDescription>
                Whizmanage offers extensive features for product editing,
                viewing, filtering, deleting, restoring, downloading, and
                saving. Enjoy a user-friendly interface packed with powerful
                tools.
              </CardDescription>
              <CardSkeletonContainer>
                <SkeletonOne />
              </CardSkeletonContainer>
            </Card>
          </div>
          <div className="lg:col-span-1">
            <Card>
              <CardSkeletonContainer className="max-w-[16rem] mx-auto">
                <SkeletonTwo />
              </CardSkeletonContainer>
              <CardTitle>Boost Your Sales</CardTitle>
              <CardDescription>
                Optimize store management with Whizmanage to drive sales growth
                and improve customer satisfaction.
              </CardDescription>
            </Card>
          </div>
          <div className="lg:col-span-1">
            <Card>
              <CardSkeletonContainer>
                <SkeletonThree />
              </CardSkeletonContainer>
              <CardTitle>Smart Integration</CardTitle>
              <CardDescription>
                Whizmanage seamlessly integrates with popular management and
                enhancement tools.
              </CardDescription>
            </Card>
          </div>
          <div className="lg:col-span-2">
            <Card>
              <CardSkeletonContainer
                showGradient={false}
                className="max-w-[16rem] mx-auto"
              >
                <SkeletonFour />
              </CardSkeletonContainer>
              <CardTitle>Advanced Editing Capabilities</CardTitle>
              <CardDescription>
                Whizmanage provides comprehensive control for editing and
                managing your store's products effortlessly.
              </CardDescription>
            </Card>
          </div>
          {/* <Card>
            <CardSkeletonContainer>
              <SkeletonFive />
            </CardSkeletonContainer>
            <CardTitle>Know Your Customers</CardTitle>
            <CardDescription>
              Create tailored funnels based on your target audience and drive
              more traffic to your store.
            </CardDescription>
          </Card> */}
        </div>
      </Container>
    </GradientContainer>
  );
};
